// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  IsDashboard: true,
  // WebserviceUrl: "http://localhost/cargo/Api/",
  // MvcWebUrl: "http://localhost/cargo/",
  // WebUrl: "http://localhost:4200/#",

  WebserviceUrl: "http://115.241.20.42/AASH/API/",
  MvcWebUrl: "http://115.241.20.42/AASH/",
  WebUrl: "http://115.241.20.42/#",

  // WebserviceUrl: "http://115.241.20.42/AASHOLDSERVICE/API/",
  // MvcWebUrl: "http://115.241.20.42/AASHOLDSERVICE/",
  // WebUrl: "http://115.241.20.42/AASHOLDAPP/#",
  ApiUserName: "aashlogistic",
  ApiPassword: "aashlogisticNoida",
  // ApiUserName: "aashlogisticOld",
  // ApiPassword: "aashlogisticNoidaOld",
  gstin: "09AAFCA7829R1ZT",
  token: ''
};


/*
// WebserviceUrl: "http://14.99.197.218/AASH/API/",
// MvcWebUrl: "http://14.99.197.218/AASH/",
// WebUrl: "http://14.99.197.218/#",

http://localhost/cargo/Api/
///http://182.75.17.10/cargodemoservice/api/
///http://182.75.17.10/cargodemoservice/

http://3.6.220.91/AASH/API/   --Prod new
http://3.6.220.91/AASH/

///http://45.122.120.7:8085/AASHSERVICE/API/  --Prod
///http://45.122.120.7:8085/AASHSERVICE/

// WebserviceUrl: "http://localhost/cargo/Api/",
// MvcWebUrl: "http://localhost/cargo/",
// WebUrl: "http://localhost:4200/#",

*
 *ng build --outputHashing=all
 *For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 * This import should be commented out in production mode because it will have a negative impact=====
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
